export enum TipoIAWhatsApp {
    NENHUMA = "NENHUMA",
    CHATGPT = "CHATGPT"
}

export enum TipoIAWhatsAppDescricao {
    NENHUMA = "Nenhuma",
    CHATGPT = "ChatGPT"
}
